import React from 'react';
import fieldComponents from '../../../config/utils/fieldComponents';
import logger from '../../../../../utils/logger';
import { isCampoVisivel } from '../../utils/validation';
import { FieldWrapper } from './styles';

// Campos de identidade vindos do cadastro na OAB: mesmo que o pedido permita
// tecnicamente editá-los, a mudança nunca é persistida (não estão na whitelist do
// PUT /pessoa/:id — ver core/services/perfilPrefillService.js) e editar geraria a
// falsa impressão de que "salvou". Travados como somente leitura em qualquer pedido
// que os use, independente do config.js. `nomeSociedade`/`cnpj` não entram aqui:
// pra PF Advogado(a) são os dados de outra pessoa (a sociedade do pedido) e
// precisam ser digitados. Pra PJ — que é a própria sociedade — eles já chegam
// preenchidos com o dado do login e com `disabled` (ver adaptarConfigAoPerfil).
const CAMPOS_SOMENTE_LEITURA = new Set(['nomeCompleto', 'cpf', 'numeroOAB']);

const DynamicField = ({ field, value, error, touched, onChange, onBlur, formData, setErrors }) => {
  const Component = fieldComponents[field.type];

  if (!Component) {
    logger.warn(`Tipo de campo não encontrado: ${field.type}`);
    return null;
  }

  // Campo condicional
  if (!isCampoVisivel(field, formData)) {
    return null;
  }

  const campoField = CAMPOS_SOMENTE_LEITURA.has(field.name) ? { ...field, disabled: true } : field;
  
  // Campos que ocupam largura total no grid
  const isFullWidth = field.type === 'textarea' || field.type === 'checkbox' || field.type === 'radio' || field.type === 'multiSelect';
  
  return (
    <FieldWrapper
      data-field-name={field.name}
      style={isFullWidth ? { gridColumn: '1 / -1' } : undefined}
    >
      <Component
        field={campoField}
        value={value}
        error={error}
        touched={touched}
        onChange={onChange}
        onBlur={onBlur}
        formData={formData}
        setErrors={setErrors}
      />
    </FieldWrapper>
  );
};

export default DynamicField;